var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoInputNumber is a wrapper around PrimeReact's InputNumber component,
 * providing consistent styling and forwarding props in a reusable format.
 *
 * @component
 * @example
 * <BeoInputNumber
 *   value={value}
 *   onChange={(e) => setValue(e.value)}
 *   min={0}
 *   max={9999999}
 * />
 *
 * @param {BeoInputNumberProps} props - Props including value, onChange, min, max, and other InputNumber props.
 * @param {React.Ref} [props.ref] - Ref forwarded to the underlying InputNumber.
 * @returns {JSX.Element} The styled PrimeReact InputNumber component.
 */
import { InputNumber } from "primereact/inputnumber";
var BeoInputNumber = function (_a) {
    var ref = _a.ref, props = __rest(_a, ["ref"]);
    return (_jsx(InputNumber, __assign({ ref: ref, className: "w-full custom-height  ".concat(props.className) }, props)));
};
export default BeoInputNumber;
